const TOKEN_STORAGE_KEY = "blackadder:api_token";
export const AUTH_TOKEN_QUERY_KEY = "authToken";
const COOKIE_NAME = "api_token";

const getStorage = (): Storage | null => {
	if (typeof window === "undefined") {
		return null;
	}

	try {
		return window.localStorage;
	} catch {
		return null;
	}
};

const readTokenFromCookie = (): string | null => {
	if (typeof document === "undefined") {
		return null;
	}

	const cookies = document.cookie.split(";");
	const apiTokenCookie = cookies.find((cookie) =>
		cookie.trim().startsWith(`${COOKIE_NAME}=`)
	);

	if (!apiTokenCookie) {
		return null;
	}

	const [, value] = apiTokenCookie.split("=");
	return value ? decodeURIComponent(value) : null;
};

const clearCookieToken = () => {
	if (typeof document === "undefined") {
		return;
	}

	const host =
		typeof window !== "undefined" ? window.location.hostname : undefined;
	const domains = new Set<string>([""]);

	if (host) {
		domains.add(host);
		if (host.endsWith(".blackadder.local") || host === "blackadder.local") {
			domains.add(".blackadder.local");
		}
		if (
			host.endsWith(".blackadder.co.jp") ||
			host === "blackadder.co.jp"
		) {
			domains.add(".blackadder.co.jp");
		}
	}

	domains.forEach((domain) => {
		const domainPart = domain ? `; domain=${domain}` : "";
		document.cookie = `${COOKIE_NAME}=; Max-Age=0; Path=/${domainPart}; Secure; SameSite=None`;
	});
};

export const getAuthToken = (): string | null => {
	const storage = getStorage();
	if (storage) {
		const stored = storage.getItem(TOKEN_STORAGE_KEY);
		if (stored) {
			return stored;
		}
	}

	const cookieToken = readTokenFromCookie();
	if (cookieToken && storage) {
		storage.setItem(TOKEN_STORAGE_KEY, cookieToken);
	}
	return cookieToken;
};

export const storeAuthToken = (token: string) => {
	const storage = getStorage();
	if (storage) {
		storage.setItem(TOKEN_STORAGE_KEY, token);
	}
};

export const clearAuthToken = () => {
	const storage = getStorage();
	if (storage) {
		storage.removeItem(TOKEN_STORAGE_KEY);
	}
	clearCookieToken();
};

export const bootstrapTokenFromUrl = (): string | null => {
	if (typeof window === "undefined") {
		return null;
	}

	try {
		const url = new URL(window.location.href);
		const token = url.searchParams.get(AUTH_TOKEN_QUERY_KEY);

		if (!token) {
			return null;
		}

		storeAuthToken(token);
		url.searchParams.delete(AUTH_TOKEN_QUERY_KEY);

		const cleanUrl = `${url.pathname}${url.search}${url.hash}`;
		window.history.replaceState({}, document.title, cleanUrl);
		return token;
	} catch {
		return null;
	}
};
